function CloseIcon(props) {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4685 1.58565C21.792 1.32689 21.8444 0.854922 21.5857 0.531476C21.3269 0.208029 20.855 0.155588 20.5315 0.414346L17.2062 3.0746C15.529 1.56832 13.3897 0.249997 11 0.249997C8.85907 0.249997 6.92327 1.30899 5.35175 2.59571C3.77166 3.88946 2.47964 5.47865 1.61144 6.68801L1.53984 6.78759C1.01718 7.51382 0.58695 8.11163 0.586944 8.99997C0.586937 9.8883 1.01709 10.486 1.53964 11.2121L1.61121 11.3117C2.15751 12.0727 2.86909 12.9804 3.71226 13.8697L0.531506 16.4143C0.20806 16.6731 0.155619 17.1451 0.414376 17.4685C0.673133 17.792 1.1451 17.8444 1.46855 17.5856L21.4685 1.58565ZM11 1.75C12.7777 1.75 14.5024 2.70929 16.0173 4.02571L13.4006 6.11906C12.7506 5.57703 11.9134 5.25 11 5.25C8.92896 5.25 7.25003 6.92893 7.25003 9C7.25003 9.61538 7.39871 10.197 7.66192 10.71L4.88803 12.9291C4.06702 12.0746 3.36802 11.1867 2.82974 10.4369C2.20595 9.56798 2.08694 9.35851 2.08694 8.99998C2.08695 8.64146 2.206 8.43192 2.82995 7.56278C3.65922 6.40765 4.86351 4.93414 6.30203 3.75631C7.74913 2.57146 9.35426 1.75 11 1.75ZM11 6.75C11.4362 6.75 11.8433 6.8738 12.1884 7.08887L8.87436 9.74007C8.79377 9.5085 8.75003 9.25961 8.75003 9C8.75003 7.75736 9.75739 6.75 11 6.75Z"
        fill="#777186"
      />
      <path
        d="M19.3954 5.39076C19.1332 5.07003 18.6608 5.02252 18.34 5.28464C18.0193 5.54676 17.9718 6.01925 18.2339 6.33998C18.5844 6.76885 18.8981 7.18393 19.17 7.5627C19.7941 8.43191 19.9131 8.64147 19.9131 8.99999C19.9131 9.35852 19.7941 9.56806 19.1701 10.4372C18.3408 11.5923 17.1365 13.0659 15.698 14.2437C14.2509 15.4285 12.6458 16.25 11 16.25C9.59522 16.25 8.21821 15.652 6.93756 14.7322C6.60113 14.4905 6.13252 14.5674 5.89088 14.9038C5.64923 15.2402 5.72607 15.7088 6.0625 15.9505C7.48703 16.9737 9.16761 17.75 11 17.75C13.141 17.75 15.0768 16.691 16.6483 15.4043C18.2284 14.1105 19.5204 12.5213 20.3886 11.312L20.4602 11.2124C20.9829 10.4862 21.4131 9.88834 21.4131 8.99999C21.4131 8.11164 20.9829 7.51379 20.4602 6.78751L20.3886 6.68793C20.1009 6.28721 19.7682 5.84693 19.3954 5.39076Z"
        fill="#777186"
      />
      <path
        d="M14.75 9C14.75 8.58578 14.4142 8.25 14 8.25C13.5858 8.25 13.25 8.58578 13.25 9C13.25 10.2426 12.2427 11.25 11 11.25C10.5858 11.25 10.25 11.5858 10.25 12C10.25 12.4142 10.5858 12.75 11 12.75C13.0711 12.75 14.75 11.0711 14.75 9Z"
        fill="#777186"
      />
    </svg>
  );
}

function OpenIcon(props) {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7784 11.5889L20.3876 12.0263L19.7784 11.5889ZM19.7784 7.83971L19.1691 8.27709L19.7784 7.83971ZM2.2197 11.5889L2.82895 11.1515L2.2197 11.5889ZM2.2197 7.83971L1.61044 7.40232L2.2197 7.83971ZM1.33594 9.71431H0.585937H1.33594ZM1.61044 12.0263C2.47864 13.2357 3.77066 14.8248 5.35076 16.1186C6.92227 17.4053 8.85807 18.4643 10.999 18.4643V16.9643C9.35326 16.9643 7.74813 16.1429 6.30103 14.958C4.86251 13.7802 3.65822 12.3067 2.82895 11.1515L1.61044 12.0263ZM10.999 18.4643C13.14 18.4643 15.0758 17.4053 16.6473 16.1186C18.2274 14.8248 19.5194 13.2357 20.3876 12.0263L19.1691 11.1515C18.3398 12.3067 17.1355 13.7802 15.697 14.958C14.2499 16.1428 12.6448 16.9643 10.999 16.9643V18.4643ZM20.3876 7.40232C19.5194 6.19296 18.2274 4.60377 16.6473 3.31002C15.0758 2.0233 13.14 0.96431 10.999 0.96431V2.46431C12.6448 2.46431 14.2499 3.28577 15.697 4.47062C17.1355 5.64845 18.3398 7.12196 19.1691 8.27709L20.3876 7.40232ZM10.999 0.96431C8.85807 0.96431 6.92227 2.0233 5.35076 3.31002C3.77066 4.60377 2.47864 6.19296 1.61044 7.40232L2.82895 8.27709C3.65822 7.12196 4.86251 5.64845 6.30103 4.47062C7.74813 3.28577 9.35326 2.46431 10.999 2.46431V0.96431ZM20.3876 12.0263C20.942 11.2541 21.4121 10.6429 21.4121 9.71431H19.9121C19.9121 10.0728 19.7931 10.2824 19.1691 11.1515L20.3876 12.0263ZM19.1691 8.27709C19.7931 9.14625 19.9121 9.35579 19.9121 9.71431H21.4121C21.4121 8.7857 20.942 8.17455 20.3876 7.40232L19.1691 8.27709ZM2.82895 11.1515C2.20499 10.2824 2.08594 10.0728 2.08594 9.71431H0.585937C0.585937 10.6429 1.05606 11.2541 1.61044 12.0263L2.82895 11.1515ZM1.61044 7.40232C1.05606 8.17455 0.585937 8.7857 0.585937 9.71431H2.08594C2.08594 9.35579 2.20499 9.14625 2.82895 8.27709L1.61044 7.40232ZM7.24903 9.71431C7.24903 11.7854 8.92796 13.4643 10.999 13.4643V11.9643C9.75639 11.9643 8.74903 10.957 8.74903 9.71431H7.24903ZM10.999 13.4643C13.0701 13.4643 14.749 11.7854 14.749 9.71431H13.249C13.249 10.957 12.2417 11.9643 10.999 11.9643V13.4643ZM14.749 9.71431C14.749 7.64324 13.0701 5.96431 10.999 5.96431V7.46431C12.2417 7.46431 13.249 8.47167 13.249 9.71431H14.749ZM10.999 5.96431C8.92796 5.96431 7.24903 7.64324 7.24903 9.71431H8.74903C8.74903 8.47167 9.75639 7.46431 10.999 7.46431V5.96431Z"
        fill="#777186"
      />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg
      width="26"
      height="20"
      viewBox="0 0 26 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.1773 4.49011L11.0938 18.5732C10.6713 18.9957 10.1167 19.2083 9.56207 19.2083C9.00745 19.2083 8.45282 18.9957 8.0303 18.5732L0.988769 11.5316C0.141357 10.6846 0.141357 9.31513 0.988769 8.46811C1.83578 7.6207 3.20489 7.6207 4.05231 8.46811L9.56207 13.9779L22.1138 1.42657C22.9608 0.579163 24.3299 0.579163 25.1773 1.42657C26.0243 2.27359 26.0243 3.6427 25.1773 4.49011V4.49011Z"
        fill="#3EBE61"
      />
    </svg>
  );
}

function NewCheckIcon() {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_381_2619)">
        <path
          opacity="0.1"
          d="M26 0C11.663 0 0 11.663 0 26C0 40.337 11.663 52 26 52C40.337 52 52 40.337 52 26C52 11.663 40.337 0 26 0Z"
          fill="#3EBE61"
        />
        <path
          d="M39.1773 20.4901L25.0938 34.5732C24.6713 34.9957 24.1167 35.2083 23.5621 35.2083C23.0074 35.2083 22.4528 34.9957 22.0303 34.5732L14.9888 27.5316C14.1414 26.6846 14.1414 25.3151 14.9888 24.4681C15.8358 23.6207 17.2049 23.6207 18.0523 24.4681L23.5621 29.9779L36.1138 17.4266C36.9608 16.5792 38.3299 16.5792 39.1773 17.4266C40.0243 18.2736 40.0243 19.6427 39.1773 20.4901Z"
          fill="#3EBE61"
        />
      </g>
      <defs>
        <clipPath id="clip0_381_2619">
          <rect width="52" height="52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function BackArrow() {
  return (
    <svg
      width="21"
      height="15"
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4062 7.09375H1.59375"
        stroke="#23143E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.53125 1.15625L1.59375 7.09375L7.53125 13.0312"
        stroke="#23143E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CopyLink() {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4766 15.2039L19.5868 16.0937C19.3452 16.3353 18.9445 16.3353 18.7029 16.0937C18.4613 15.8521 18.4613 15.4514 18.7029 15.2098L19.5927 14.32C21.1366 12.7762 21.1366 10.2659 19.5927 8.72209C18.0489 7.17824 15.5386 7.17824 13.9948 8.72209L13.1109 9.60597C12.8693 9.84757 12.4686 9.84757 12.227 9.60597C11.9854 9.36438 11.9795 8.96957 12.227 8.72209L13.1109 7.8382C15.1438 5.80527 18.4437 5.80527 20.4766 7.8382C22.5095 9.87114 22.5095 13.171 20.4766 15.2039Z"
        fill="#817A8E"
      />
      <path
        d="M16.0572 19.6232L15.1733 20.5071C13.1404 22.54 9.84053 22.54 7.8076 20.5071C5.77467 18.4741 5.77467 15.1743 7.8076 13.1414L8.69149 12.2575C8.93308 12.0159 9.33378 12.0159 9.57537 12.2575C9.81696 12.4991 9.81697 12.8998 9.57537 13.1414L8.69149 14.0253C7.14764 15.5691 7.14764 18.0793 8.69149 19.6232C10.2353 21.167 12.7456 21.167 14.2894 19.6232L15.1733 18.7393C15.4149 18.4977 15.8156 18.4977 16.0572 18.7393C16.2988 18.9809 16.2988 19.3816 16.0572 19.6232Z"
        fill="#817A8E"
      />
      <path
        d="M16.9411 12.2572L12.2271 16.9712C11.9855 17.2128 11.5848 17.2128 11.3432 16.9712C11.1016 16.7296 11.1016 16.3289 11.3432 16.0874L16.0572 11.3733C16.2988 11.1317 16.6995 11.1317 16.9411 11.3733C17.1827 11.6149 17.1827 12.0156 16.9411 12.2572Z"
        fill="#817A8E"
      />
    </svg>
  );
}

function PushNotificationIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5208 21.3857C10.0937 21.3857 7.66661 21.0003 5.36453 20.2295C4.48953 19.9274 3.82286 19.3128 3.5312 18.5107C3.22911 17.7087 3.33328 16.8232 3.81245 16.0316L5.01036 14.042C5.26036 13.6253 5.48953 12.792 5.48953 12.3024V9.29199C5.48953 5.41699 8.64578 2.26074 12.5208 2.26074C16.3958 2.26074 19.552 5.41699 19.552 9.29199V12.3024C19.552 12.7816 19.7812 13.6253 20.0312 14.0524L21.2187 16.0316C21.6666 16.7816 21.7499 17.6878 21.4479 18.5107C21.1458 19.3337 20.4895 19.9587 19.6666 20.2295C17.3749 21.0003 14.9479 21.3857 12.5208 21.3857ZM12.5208 3.82324C9.51036 3.82324 7.05203 6.27116 7.05203 9.29199V12.3024C7.05203 13.0628 6.73953 14.1878 6.35411 14.8441L5.15619 16.8337C4.92703 17.2191 4.86453 17.6253 4.99995 17.9691C5.12495 18.3232 5.43745 18.5941 5.86453 18.7399C10.2187 20.1982 14.8333 20.1982 19.1874 18.7399C19.5624 18.6149 19.8541 18.3337 19.9895 17.9587C20.1249 17.5837 20.0937 17.1774 19.8854 16.8337L18.6874 14.8441C18.2916 14.167 17.9895 13.0524 17.9895 12.292V9.29199C17.9895 6.27116 15.5416 3.82324 12.5208 3.82324Z"
        fill="#292D32"
      />
      <path
        d="M14.4583 4.10352C14.3854 4.10352 14.3125 4.0931 14.2396 4.07227C13.9375 3.98893 13.6458 3.92643 13.3646 3.88477C12.4791 3.77018 11.625 3.83268 10.8229 4.07227C10.5312 4.16602 10.2187 4.07227 10.0208 3.85352C9.82289 3.63477 9.76039 3.32227 9.87498 3.04102C10.3021 1.94727 11.3437 1.22852 12.5312 1.22852C13.7187 1.22852 14.7604 1.93685 15.1875 3.04102C15.2916 3.32227 15.2396 3.63477 15.0416 3.85352C14.8854 4.02018 14.6666 4.10352 14.4583 4.10352Z"
        fill="#292D32"
      />
      <path
        d="M12.5209 23.7598C11.4896 23.7598 10.4896 23.3431 9.76046 22.6139C9.03129 21.8848 8.61462 20.8848 8.61462 19.8535H10.1771C10.1771 20.4681 10.4271 21.0723 10.8646 21.5098C11.3021 21.9473 11.9063 22.1973 12.5209 22.1973C13.8125 22.1973 14.8646 21.1452 14.8646 19.8535H16.4271C16.4271 22.0098 14.6771 23.7598 12.5209 23.7598Z"
        fill="#292D32"
      />
    </svg>
  );
}

function ChangePasswordIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 11.1976C18.3229 11.1976 17.9687 10.8434 17.9687 10.4163V8.33301C17.9687 5.05176 17.0417 2.86426 12.5 2.86426C7.95833 2.86426 7.03125 5.05176 7.03125 8.33301V10.4163C7.03125 10.8434 6.67708 11.1976 6.25 11.1976C5.82292 11.1976 5.46875 10.8434 5.46875 10.4163V8.33301C5.46875 5.31217 6.19792 1.30176 12.5 1.30176C18.8021 1.30176 19.5312 5.31217 19.5312 8.33301V10.4163C19.5312 10.8434 19.1771 11.1976 18.75 11.1976Z"
        fill="#292D32"
      />
      <path
        d="M12.5 20.0521C10.6354 20.0521 9.11456 18.5313 9.11456 16.6667C9.11456 14.8021 10.6354 13.2812 12.5 13.2812C14.3646 13.2812 15.8854 14.8021 15.8854 16.6667C15.8854 18.5313 14.3646 20.0521 12.5 20.0521ZM12.5 14.8438C11.5 14.8438 10.6771 15.6667 10.6771 16.6667C10.6771 17.6667 11.5 18.4896 12.5 18.4896C13.5 18.4896 14.3229 17.6667 14.3229 16.6667C14.3229 15.6667 13.5 14.8438 12.5 14.8438Z"
        fill="#292D32"
      />
      <path
        d="M17.7084 23.6982H7.29171C2.69796 23.6982 1.30212 22.3024 1.30212 17.7087V15.6253C1.30212 11.0316 2.69796 9.63574 7.29171 9.63574H17.7084C22.3021 9.63574 23.698 11.0316 23.698 15.6253V17.7087C23.698 22.3024 22.3021 23.6982 17.7084 23.6982ZM7.29171 11.1982C3.56254 11.1982 2.86462 11.9066 2.86462 15.6253V17.7087C2.86462 21.4274 3.56254 22.1357 7.29171 22.1357H17.7084C21.4375 22.1357 22.1355 21.4274 22.1355 17.7087V15.6253C22.1355 11.9066 21.4375 11.1982 17.7084 11.1982H7.29171Z"
        fill="#292D32"
      />
    </svg>
  );
}

function TermsIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6666 23.6976H8.33329C5.18746 23.6976 3.38538 21.8955 3.38538 18.7497V8.59342C3.38538 5.31217 5.05204 3.64551 8.33329 3.64551C8.76038 3.64551 9.11454 3.99967 9.11454 4.42676C9.11454 4.84342 9.28121 5.23926 9.57288 5.53092C9.86454 5.82259 10.2604 5.98926 10.677 5.98926H14.3229C15.1875 5.98926 15.8854 5.29134 15.8854 4.42676C15.8854 3.99967 16.2395 3.64551 16.6666 3.64551C19.9479 3.64551 21.6145 5.31217 21.6145 8.59342V18.7497C21.6145 21.8955 19.8125 23.6976 16.6666 23.6976ZM7.65618 5.22885C6.01035 5.36426 4.94788 6.10384 4.94788 8.59342V18.7497C4.94788 21.0622 6.02079 22.1351 8.33329 22.1351H16.6666C18.9791 22.1351 20.052 21.0622 20.052 18.7497V8.59342C20.052 6.10384 18.9896 5.37468 17.3437 5.22885C16.9896 6.56218 15.7708 7.55176 14.3229 7.55176H10.677C9.84371 7.55176 9.06246 7.22884 8.46871 6.63509C8.07288 6.23925 7.80202 5.7601 7.65618 5.22885Z"
        fill="#292D32"
      />
      <path
        d="M14.323 7.55176H10.6771C9.84379 7.55176 9.06255 7.22884 8.4688 6.63509C7.87505 6.04134 7.55212 5.26009 7.55212 4.42676C7.55212 2.70801 8.95837 1.30176 10.6771 1.30176H14.323C15.1563 1.30176 15.9375 1.62468 16.5313 2.21843C17.125 2.81218 17.448 3.59342 17.448 4.42676C17.448 6.14551 16.0417 7.55176 14.323 7.55176ZM10.6771 2.86426C9.81254 2.86426 9.11462 3.56217 9.11462 4.42676C9.11462 4.84342 9.28129 5.23926 9.57296 5.53092C9.86463 5.82259 10.2605 5.98926 10.6771 5.98926H14.323C15.1875 5.98926 15.8855 5.29134 15.8855 4.42676C15.8855 4.01009 15.7188 3.61426 15.4271 3.32259C15.1355 3.03093 14.7396 2.86426 14.323 2.86426H10.6771Z"
        fill="#292D32"
      />
      <path
        d="M12.5 14.3232H8.33337C7.90629 14.3232 7.55212 13.9691 7.55212 13.542C7.55212 13.1149 7.90629 12.7607 8.33337 12.7607H12.5C12.9271 12.7607 13.2813 13.1149 13.2813 13.542C13.2813 13.9691 12.9271 14.3232 12.5 14.3232Z"
        fill="#292D32"
      />
      <path
        d="M16.6667 18.4893H8.33337C7.90629 18.4893 7.55212 18.1351 7.55212 17.708C7.55212 17.2809 7.90629 16.9268 8.33337 16.9268H16.6667C17.0938 16.9268 17.448 17.2809 17.448 17.708C17.448 18.1351 17.0938 18.4893 16.6667 18.4893Z"
        fill="#292D32"
      />
    </svg>
  );
}

function FaqIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33337 23.2503C8.04171 23.2503 7.73961 23.1774 7.46877 23.0316C6.87502 22.7191 6.51046 22.094 6.51046 21.4273V19.9483C3.36462 19.6253 1.30212 17.3128 1.30212 14.0003V7.75033C1.30212 4.16699 3.70837 1.76074 7.29171 1.76074H17.7084C21.2917 1.76074 23.698 4.16699 23.698 7.75033V14.0003C23.698 17.5836 21.2917 19.9898 17.7084 19.9898H13.7813L9.34376 22.9483C9.04168 23.1462 8.68754 23.2503 8.33337 23.2503ZM7.29171 3.31282C4.60421 3.31282 2.86462 5.0524 2.86462 7.7399V13.99C2.86462 16.6775 4.60421 18.417 7.29171 18.417C7.71879 18.417 8.07296 18.7712 8.07296 19.1983V21.417C8.07296 21.5525 8.1563 21.6149 8.20838 21.6462C8.26046 21.6774 8.36464 21.7087 8.47922 21.6358L13.1147 18.5525C13.2397 18.4691 13.3959 18.417 13.5521 18.417H17.7188C20.4063 18.417 22.1459 16.6775 22.1459 13.99V7.7399C22.1459 5.0524 20.4063 3.31282 17.7188 3.31282H7.29171Z"
        fill="#292D32"
      />
      <path
        d="M12.4998 12.6143C12.0727 12.6143 11.7185 12.2601 11.7185 11.833V11.6143C11.7185 10.406 12.6039 9.8122 12.9373 9.58304C13.3227 9.32262 13.4477 9.14554 13.4477 8.87471C13.4477 8.35388 13.0206 7.92676 12.4998 7.92676C11.9789 7.92676 11.5519 8.35388 11.5519 8.87471C11.5519 9.30179 11.1977 9.65596 10.7706 9.65596C10.3435 9.65596 9.98938 9.30179 9.98938 8.87471C9.98938 7.48929 11.1144 6.36426 12.4998 6.36426C13.8852 6.36426 15.0102 7.48929 15.0102 8.87471C15.0102 10.0622 14.1352 10.6559 13.8123 10.8747C13.406 11.1455 13.281 11.3226 13.281 11.6143V11.833C13.281 12.2705 12.9269 12.6143 12.4998 12.6143Z"
        fill="#292D32"
      />
      <path
        d="M12.5 15.208C12.0625 15.208 11.7188 14.8538 11.7188 14.4268C11.7188 13.9997 12.0729 13.6455 12.5 13.6455C12.9271 13.6455 13.2812 13.9997 13.2812 14.4268C13.2812 14.8538 12.9375 15.208 12.5 15.208Z"
        fill="#292D32"
      />
    </svg>
  );
}

function SettingShareIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 8.33301L8.33337 11.458L16.6667 8.33301ZM16.6667 16.6663L8.33337 13.5413L16.6667 16.6663Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M6.24996 14.5837C7.40055 14.5837 8.33329 13.6509 8.33329 12.5003C8.33329 11.3497 7.40055 10.417 6.24996 10.417C5.09937 10.417 4.16663 11.3497 4.16663 12.5003C4.16663 13.6509 5.09937 14.5837 6.24996 14.5837Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M18.75 9.37468C19.9006 9.37468 20.8333 8.44194 20.8333 7.29134C20.8333 6.14075 19.9006 5.20801 18.75 5.20801C17.5994 5.20801 16.6666 6.14075 16.6666 7.29134C16.6666 8.44194 17.5994 9.37468 18.75 9.37468Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M18.75 19.7917C19.9006 19.7917 20.8333 18.8589 20.8333 17.7083C20.8333 16.5577 19.9006 15.625 18.75 15.625C17.5994 15.625 16.6666 16.5577 16.6666 17.7083C16.6666 18.8589 17.5994 19.7917 18.75 19.7917Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}

function DeleteIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8751 7.01074C21.8542 7.01074 21.823 7.01074 21.7917 7.01074C16.2813 6.45865 10.7813 6.25032 5.3334 6.8024L3.2084 7.01074C2.7709 7.0524 2.38548 6.7399 2.34381 6.3024C2.30215 5.8649 2.61465 5.4899 3.04173 5.44824L5.16673 5.2399C10.7084 4.6774 16.323 4.89615 21.948 5.44824C22.3751 5.4899 22.6876 5.87532 22.6459 6.3024C22.6146 6.70865 22.2709 7.01074 21.8751 7.01074Z"
        fill="#292D32"
      />
      <path
        d="M8.85417 5.95801C8.8125 5.95801 8.77083 5.95801 8.71875 5.94759C8.30208 5.87467 8.01042 5.46842 8.08333 5.05176L8.3125 3.68717C8.47917 2.68717 8.70833 1.30176 11.1354 1.30176H13.8646C16.3021 1.30176 16.5312 2.73926 16.6875 3.69759L16.9167 5.05176C16.9896 5.47884 16.6979 5.88509 16.2812 5.94759C15.8542 6.02051 15.4479 5.72884 15.3854 5.31217L15.1562 3.95801C15.0104 3.05176 14.9792 2.87467 13.875 2.87467H11.1458C10.0417 2.87467 10.0208 3.02051 9.86458 3.94759L9.625 5.30176C9.5625 5.68717 9.22917 5.95801 8.85417 5.95801Z"
        fill="#292D32"
      />
      <path
        d="M15.8437 23.6976H9.15625C5.52083 23.6976 5.375 21.6872 5.26041 20.0622L4.58333 9.57257C4.55208 9.14548 4.88541 8.77048 5.3125 8.73923C5.75 8.7184 6.11458 9.04132 6.14583 9.4684L6.82291 19.958C6.9375 21.5413 6.97916 22.1351 9.15625 22.1351H15.8437C18.0312 22.1351 18.0729 21.5413 18.1771 19.958L18.8542 9.4684C18.8854 9.04132 19.2604 8.7184 19.6875 8.73923C20.1146 8.77048 20.4479 9.13507 20.4167 9.57257L19.7396 20.0622C19.625 21.6872 19.4792 23.6976 15.8437 23.6976Z"
        fill="#292D32"
      />
      <path
        d="M14.2291 17.9688H10.7604C10.3333 17.9688 9.97913 17.6146 9.97913 17.1875C9.97913 16.7604 10.3333 16.4062 10.7604 16.4062H14.2291C14.6562 16.4062 15.0104 16.7604 15.0104 17.1875C15.0104 17.6146 14.6562 17.9688 14.2291 17.9688Z"
        fill="#292D32"
      />
      <path
        d="M15.1042 13.8018H9.89587C9.46879 13.8018 9.11462 13.4476 9.11462 13.0205C9.11462 12.5934 9.46879 12.2393 9.89587 12.2393H15.1042C15.5313 12.2393 15.8855 12.5934 15.8855 13.0205C15.8855 13.4476 15.5313 13.8018 15.1042 13.8018Z"
        fill="#292D32"
      />
    </svg>
  );
}

function LeftArrowIcon() {
  return (
    <svg
      width="9"
      height="19"
      viewBox="0 0 9 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.393232 16.4691C-0.0725795 16.9307 -0.0759345 17.6826 0.385739 18.1484C0.847414 18.6142 1.59929 18.6176 2.0651 18.1559L4.90676 15.3395C5.97705 14.2788 6.8518 13.4118 7.47216 12.6394C8.11726 11.8361 8.58423 11.0208 8.70898 10.0421C8.76367 9.61296 8.76367 9.1787 8.70898 8.74958C8.58423 7.7709 8.11725 6.95558 7.47216 6.15231C6.8518 5.37985 5.97706 4.51291 4.90678 3.45217L2.0651 0.635739C1.59929 0.174067 0.847413 0.17742 0.385739 0.643231C-0.075935 1.10904 -0.0725808 1.86092 0.393232 2.32259L3.1846 5.08917C4.31746 6.21197 5.09457 6.9847 5.62039 7.63945C6.13117 8.27547 6.3064 8.68399 6.35304 9.04987C6.38232 9.27961 6.38232 9.51206 6.35304 9.7418C6.3064 10.1077 6.13117 10.5162 5.62039 11.1522C5.09457 11.807 4.31746 12.5797 3.1846 13.7025L0.393232 16.4691Z"
        fill="#2D264B"
      />
    </svg>
  );
}

function PopupCloseIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.13388 0.366116C1.64573 -0.122039 0.854272 -0.122039 0.366116 0.366116C-0.122039 0.854272 -0.122039 1.64573 0.366116 2.13388L7.95861 9.72638L0.366116 17.3189C-0.122039 17.807 -0.122039 18.5985 0.366116 19.0866C0.854272 19.5748 1.64573 19.5748 2.13388 19.0866L9.72638 11.4941L17.3189 19.0866C17.807 19.5748 18.5985 19.5748 19.0866 19.0866C19.5748 18.5985 19.5748 17.807 19.0866 17.3189L11.4941 9.72638L19.0866 2.13388C19.5748 1.64573 19.5748 0.854272 19.0866 0.366116C18.5985 -0.122039 17.807 -0.122039 17.3189 0.366116L9.72638 7.95861L2.13388 0.366116Z"
        fill="#D4D4D4"
      />
    </svg>
  );
}

function FilterCrossIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3027 1.70711C11.6932 1.31658 11.6932 0.683417 11.3027 0.292893C10.9122 -0.0976311 10.279 -0.0976311 9.88846 0.292893L6.40034 3.78101L2.91222 0.292893C2.5217 -0.0976311 1.88854 -0.0976311 1.49801 0.292893C1.10749 0.683417 1.10749 1.31658 1.49801 1.70711L4.98613 5.19523L0.860276 9.32108C0.469752 9.7116 0.469752 10.3448 0.860276 10.7353C1.2508 11.1258 1.88397 11.1258 2.27449 10.7353L6.40034 6.60944L10.5262 10.7353C10.9167 11.1258 11.5499 11.1258 11.9404 10.7353C12.3309 10.3448 12.3309 9.7116 11.9404 9.32108L7.81456 5.19523L11.3027 1.70711Z"
        fill="#777186"
      />
    </svg>
  );
}

function RecentSearchesIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5Z"
        stroke="#817A8E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5002 15.5002L11.7422 11.7422"
        stroke="#817A8E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SearchModalIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5304 17.4698C19.2375 17.1769 18.7626 17.1769 18.4697 17.4698C18.1768 17.7626 18.1768 18.2375 18.4697 18.5304L19.5304 17.4698ZM22.4696 22.5304C22.7625 22.8233 23.2374 22.8233 23.5303 22.5304C23.8232 22.2375 23.8232 21.7626 23.5303 21.4697L22.4696 22.5304ZM18.4697 18.5304L22.4696 22.5304L23.5303 21.4697L19.5304 17.4698L18.4697 18.5304ZM11 18.25C6.44365 18.25 2.75 14.5563 2.75 10H1.25C1.25 15.3848 5.61522 19.75 11 19.75V18.25ZM19.25 10C19.25 14.5563 15.5563 18.25 11 18.25V19.75C16.3848 19.75 20.75 15.3848 20.75 10H19.25ZM11 1.75C15.5563 1.75 19.25 5.44365 19.25 10H20.75C20.75 4.61522 16.3848 0.25 11 0.25V1.75ZM11 0.25C5.61522 0.25 1.25 4.61522 1.25 10H2.75C2.75 5.44365 6.44365 1.75 11 1.75V0.25Z"
        fill="#777186"
      />
    </svg>
  );
}

export {
  CloseIcon,
  OpenIcon,
  BackArrow,
  CopyLink,
  PushNotificationIcon,
  ChangePasswordIcon,
  TermsIcon,
  FaqIcon,
  SettingShareIcon,
  DeleteIcon,
  LeftArrowIcon,
  CheckIcon,
  PopupCloseIcon,
  NewCheckIcon,
  FilterCrossIcon,
  RecentSearchesIcon,
  SearchModalIcon,
};
